import React, { createContext, useContext, useEffect, useState } from "react";
import { getAllCurrency } from "../User/State/Currency/Action";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { publicCurrencies } = useSelector(
        (store) => store
    );
    const [selectedCurrency, setSelectedCurrency] = useState(
        localStorage.getItem("currency") || "INR"
    );
    const [selectedCountry, setSelectedCountry] = useState(
        localStorage.getItem("country") || "India"
    );
    const [selectedCurrencyRate, setSelectedCurrencyRate] = useState(
        localStorage.getItem("currencyRate") || 1
    );

    useEffect(() => {
        dispatch(getAllCurrency());
    }, [dispatch]);

    const changeCurrency = (code) => {
        setSelectedCurrency(code);
        localStorage.setItem("currency", code);
        const curr = publicCurrencies?.currencies?.response?.find(
            (c) => c.currencyCode === code
        );
        setSelectedCountry(curr.country)
        localStorage.setItem("country", curr.country);
        setSelectedCurrencyRate(exchangeRates[code])
        localStorage.setItem("currencyRate", exchangeRates[code]);
    };
    const [exchangeRates, setExchangeRates] = useState(null);

    // ✅ Load rates once
    useEffect(() => {
        const fetchRates = async () => {
            try {
                const res = await axios.get("https://open.er-api.com/v6/latest/INR");
                setExchangeRates(res.data?.rates || {});
            } catch (err) {
                console.error("Error fetching exchange rates", err);
            }
        };
        // first load पर run
        fetchRates();

        // ⏰ अगला midnight time निकालो
        const now = new Date();
        const nextMidnight = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate() + 1, // अगला दिन
            0, 0, 0, 0
        );
        const msUntilMidnight = nextMidnight.getTime() - now.getTime();

        // पहला timeout midnight तक
        const midnightTimeout = setTimeout(() => {
            fetchRates();

            // हर 24 घंटे repeat करो
            const dailyInterval = setInterval(fetchRates, 24 * 60 * 60 * 1000);
            // cleanup: interval clear करना ज़रूरी है
            return () => clearInterval(dailyInterval);
        }, msUntilMidnight);

        // cleanup
        return () => clearTimeout(midnightTimeout);
    }, []); // runs once

    // ✅ Function that only uses cached data
    const getExchangeRate = (code) => {
        if (!exchangeRates) return 1;
        return exchangeRates[code] || 1;
    };

    // Calculate shipping charge with customer price based on amount and currency ranges
    const getShippingCharge = (code, amount) => {
        const curr = publicCurrencies?.currencies?.response?.find(
            (c) => c.currencyCode === code
        );

        if (!curr || !curr.rangeCharges || !amount) return amount; // fallback: return original amount

        // Find matching range
        const matchedRange = curr.rangeCharges.find(
            (r) =>
                amount >= r.fromAmount &&
                amount <= r.toAmount
        );

        if (matchedRange) {
            const charge = (amount * matchedRange.percentage) / 100;
            return Math.round(amount + charge);
        }

        return amount; // if no matching range, return base amount
    };

    // Calculate payable amount with discount (if applied)
    const getPayableAmount = (customerAmount, discountPercent) => {
        if (discountPercent) {
            const discountAmount = (customerAmount * discountPercent) / 100;
            return Math.round(customerAmount - discountAmount); // discount apply
        }

        return customerAmount; // no discount
    };

    // Calculate payable amount with discount (if applied)
    // ✅ Calculate only additional shipping charge (not total amount)
    const getAdditionalCharge = (code, amount) => {
        const curr = publicCurrencies?.currencies?.response?.find(
            (c) => c.currencyCode === code
        );
        console.log("cur",curr)

        if (!curr || !curr.rangeCharges || !amount) return 0; // fallback: no extra charge

        // Find matching range
        const matchedRange = curr.rangeCharges.find(
            (r) => amount >= r.fromAmount && amount <= r.toAmount
        );
        console.log("range",matchedRange)

        if (matchedRange) {
            return matchedRange.percentage; // only extra charge
        }

        return 0; // no charge if range not found
    };

    const currencies = publicCurrencies?.currencies?.response

    return (
        <CurrencyContext.Provider
            value={{ currencies, selectedCurrency, selectedCountry, changeCurrency, getExchangeRate, getShippingCharge, getAdditionalCharge, getPayableAmount, selectedCurrencyRate }}
        >
            {children}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => useContext(CurrencyContext);
